import {Injectable} from '@angular/core';
import {injectLegacy} from '../../../commons/angular/utils/inject-legacy.util';
import type {BringozToastService} from '../../../commons/services/bringoz-toast.service';

/**
 * Toasts for timecard updates on the detail screen.
 */
@Injectable({
  providedIn: 'root'
})
export class TimekeepingAlertsService {

  private readonly bringozToastService = injectLegacy<BringozToastService>('bringozToastService');

  updateSuccess() {
    this.bringozToastService.success({body: 'TIMECARD_STATUS_UPDATE_SUCCESS'});
  }

  /** Shows the server message when there is one, otherwise a generic detail. */
  updateError(errorMessage?: string) {
    this.bringozToastService.error(errorMessage
      ? {body: 'TIMECARD_STATUS_UPDATE_ERROR', message: errorMessage}
      : {body: 'TIMECARD_STATUS_UPDATE_ERROR', details: 'SOMETHING_WENT_WRONG'});
  }
}
